// App specific CONSTS
export const DEFAULT_EVENT_BUS_ID = 'ksys-global-inputs';
